import React from 'react';
import PropTypes from 'prop-types';
import styles from './monitor.css';
import coin from './icon/coin.png';

const CoinMonitor = ({categoryColor, label, value}) => (
    <div className={styles.themeMonitor}>
         <img src={coin} className={styles.themeMonitorIcon}/>
         <div className={styles.themeMonitorVbg}>
            <div className={styles.themeMonitorValue}>{value}</div>
         </div>
    </div>
);

CoinMonitor.propTypes = {
    categoryColor: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ])
};

export default CoinMonitor;
